import { render, staticRenderFns } from "./xlsx.vue?vue&type=template&id=e1dc0fa0&scoped=true&"
import script from "./xlsx.vue?vue&type=script&lang=js&"
export * from "./xlsx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1dc0fa0",
  null
  
)

export default component.exports